// removed by extract-text-webpack-plugin
module.exports = {"prescriptionHeader":"prescription-history__prescriptionHeader___3HWih","prescriptionsContainer":"prescription-history__prescriptionsContainer___2kpXU","expandPrescriptions":"prescription-history__expandPrescriptions___5HAgz"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/prescription/prescription-history.css
// module id = 1182
// module chunks = 0